<ejs-dialog target=".dialogs" class="smallmenu-dialog" [visible]='visible' [animationSettings]='dialogService.getAnimationSettings()' [resizeHandles]='dialogService.getResizeHandleDirection()' [position]='dialogService.getPosition()' [isModal]="true" [allowDragging]="false" [width]="'30%'" [height]="'auto'" [zIndex]="999" [showCloseIcon]="true" (close)="close()">
  <ng-template #header>
    <app-headline [title]="('PROFILEAVATARTTITLE' | translate)" [type]="'h5'" [class]="'text-primary m-2'"></app-headline>
  </ng-template>
  <ng-template #content>
    <div class="d-flex flex-column profile-card h-100 p-3">
      <div class="d-flex flex-column justify-content-center align-items-center mb-4">
        <app-avatar [image]="profileImage()" [type]="'xxl'"></app-avatar>
        <app-headline [type]="'h5'" [title]="(profile?.first_name ?? '') + ' ' + (profile?.last_name ?? '')" [class]="'mt-2 mb-2 text-primary'"></app-headline>
        <div class="mb-3">
          <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">{{ profile?.subtitle }}</app-content>
        </div>

        <div class="d-flex align-items-center my-2 gap-3">
          @if (canCreateChat()) {
            <app-form-button
              [disabled]="isAllowedToChat() === false"
              [style]="'btn'"
              [cssClass]="'action-button btn-sm rounded-circle p-2 ' + (layoutService.getUseColorForAllButtons() ? 'bg-success' : 'bg-primary')"
              [iconClass]="'text-white fs-6 mts-icon-filled'"
              [icon]="'chat'"
              (click)="startChat()"></app-form-button>
          }
          <app-form-button
            [disabled]="!profile?.telephone || !isContactActive(profile?.active ?? '')"
            [style]="'btn'"
            [cssClass]="'action-button btn-sm rounded-circle p-2 ' + (layoutService.getUseColorForAllButtons() ? 'bg-aqua' : 'bg-primary')"
            [iconClass]="'text-white fs-6 mts-icon-filled'"
            [icon]="'phone_enabled'"
            (click)="open('tel:' + profile?.telephone)"></app-form-button>
          <app-form-button
            [disabled]="!profile?.mobile || !isContactActive(profile?.active ?? '')"
            [style]="'btn'"
            [cssClass]="'action-button btn-sm rounded-circle p-2 ' + (layoutService.getUseColorForAllButtons() ? 'bg-darkblue' : 'bg-primary')"
            [iconClass]="'text-white fs-6 mts-icon-filled'"
            [icon]="'smartphone'"
            (click)="open('tel:' + profile?.mobile)"></app-form-button>
          <app-form-button
            [disabled]="!profile?.email || !isContactActive(profile?.active ?? '')"
            [style]="'btn'"
            [cssClass]="'action-button btn-sm rounded-circle p-2 ' + (layoutService.getUseColorForAllButtons() ? 'bg-darkorange' : 'bg-primary')"
            [iconClass]="'text-white fs-6 mts-icon-filled'"
            [icon]="'mail'"
            (click)="open('mailto:' + profile?.email)"></app-form-button>
          <!-- <app-form-button (click)="true" [cssClass]="'e-btn e-flat fs-normal text-blue p-1'" [icon]="'videocam'" [iconClass]="'fs-3 m-1'"></app-form-button> -->
        </div>
      </div>
      <!-- Scrollable content-->
      <div class="custom-scrollbar overflow-y-auto">
        <ejs-accordion expandMode='Multiple'>
          <e-accordionitems>
            <e-accordionitem expanded='true'>
              <ng-template #header>
                <div>{{ 'EMAIL' | translate }}</div>
              </ng-template>
              <ng-template #content>
                <div>{{ profile?.email ? profile?.email : '-' }}</div>
              </ng-template>
            </e-accordionitem>
            <e-accordionitem>
              <ng-template #header>
                <div>{{ 'MOBILE' | translate }}</div>
              </ng-template>
              <ng-template #content>
                <div>{{ profile?.mobile ? profile?.mobile : '-' }}</div>
              </ng-template>
            </e-accordionitem>
            <e-accordionitem>
              <ng-template #header>
                <div>{{ 'TELEPHONE' | translate }}</div>
              </ng-template>
              <ng-template #content>
                <div>{{ profile?.telephone ? profile?.telephone : '-' }}</div>
              </ng-template>
            </e-accordionitem>
            <!-- REMOVED: Groups or a user are generally not shown to other users -->
            <!-- <e-accordionitem>
              <ng-template #header>
                <div>{{ 'GROUPS' | translate }}</div>
              </ng-template>
              <ng-template #content>
                <div class="row row-cols-2 row-cols-sm-3 row-cols-md-3 row-cols-lg-3 row-cols-xl-4 justify-content-start g-2 p-sm-0">
                  @if(profile?.groups?.length){
                    @for(group of profile?.groups ?? []; track $index) {
                      <div class="d-flex">
                        <div class="group-card flex-grow-1">
                          <app-avatar [image]="groupImage(group)" [name]="group.name!" [type]="'xxs'" [icon]="'group'" [border]="false"></app-avatar>
                          <app-headline [type]="'h6'" [title]="group.name!" [class]="'text-muted fs-small'"></app-headline>
                        </div>
                      </div>
                    }
                  } @else {
                    <div>-</div>
                  } 
                </div>
              </ng-template>
            </e-accordionitem> -->
          </e-accordionitems>
        </ejs-accordion>
      </div>
    </div>
  </ng-template>
</ejs-dialog>
